<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden">
            <template v-for="(activity, index) in activities">
                <v-list-item two-line :key="index" :class="activity.properties.type">
                    <v-list-item-content>
                        <v-list-item-title>{{ activity.description }}</v-list-item-title>
                        <v-list-item-subtitle>{{ activity.created_at }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider
                :key="index + 'divider'"
                ></v-divider>
            </template>
            <Drawer :show="drawer" :id="id" :cid.sync="customer" @update-drawer="updateDrawer" />
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import Drawer from './Drawer.vue'

    export default {
        props: ['id'],
        data () {
            return {
                activities: [], 
                customer: '',
                loading: false,
                token: '',
                pageTitle: '',
                drawer: false,
            }
        },
        created() {
            this.getActivities()
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        components: {
            Drawer
        },
        methods: {
            getActivities() {
                if(this.id) {
                    this.loading = true
                    axios.get('crm/job/activities?id=' + this.id)
                        .then((response) => {
                            this.loading = false
                            this.activities = response.data.activities
                            this.customer = response.data.customer
                            this.$nextTick()
                        })
                }
            },
            updateDrawer(val) {
                this.drawer = val
            },
        }
    }
</script>